"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_LOCALE_TO_BCP47 = void 0;
exports.gameLocaleToIntlLocale = gameLocaleToIntlLocale;
exports.GAME_LOCALE_TO_BCP47 = {
    br: 'pt-BR',
    cn: 'zh',
    jp: 'ja',
    ua: 'uk',
    en: 'en',
    de: 'de',
    fr: 'fr',
    ru: 'ru',
    pl: 'pl',
    es: 'es',
    it: 'it',
    ko: 'ko',
    nl: 'nl',
    hu: 'hu',
    bg: 'bg',
    nb: 'nb',
    fi: 'fi',
};
function gameLocaleToIntlLocale(lang) {
    return exports.GAME_LOCALE_TO_BCP47[lang] ?? lang;
}
